module.exports = __webpack_public_path__ + "img/hld_balance.3897f50e.png";